import CircularProgress from '@mui/material/CircularProgress';
import type {CircularProgressProps} from '@mui/material/CircularProgress';
const Loader = (props: CircularProgressProps) => {
  return <CircularProgress color="primary" {...props} />;
};

export default Loader;
